/* Handle links/buttons that point to "#add-to-cart" */
(function () {
  if (typeof document === 'undefined') return;

  function isAddToCartAnchor(el) {
    if (!el) return false;
    if (el.tagName === 'A' && (el.getAttribute('href') || '').trim() === '#add-to-cart') return true;
    
    const dh = (el.getAttribute('data-href') || '').trim();
    const h  = (el.getAttribute('href') || '').trim();
    return dh === '#add-to-cart' || h === '#add-to-cart';
  }

  function findProductForm(start) {
    if (!start) return null;

    const localForm = start.closest('form[action="/cart/add"]');
    if (localForm) return localForm;

    const mainForm = document.querySelector('form[action="/cart/add"][data-product-form]');
    if (mainForm) return mainForm;

    const allForms = document.querySelectorAll('form[action="/cart/add"]');
    for (const f of allForms) {
      if (!f.closest('product-complimentary, .upsell-slider, .quickview')) {
        return f;
      }
    }

    return document.querySelector('form[action="/cart/add"]');
  }

  function submitProductForm(form) {
    if (!form) return;

    const addBtn =
      form.querySelector('button[type="submit"][name="add"]') ||
      form.querySelector('button[name="add"]') ||
      form.querySelector('[data-add-to-cart]');

    if (addBtn) {
      addBtn.click();
      return;
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  function stripHashFromUrl() {
    if (location.hash === '#add-to-cart') {
      history.replaceState(null, '', location.pathname + location.search);
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      const target = e.target.closest('a, button');
      if (!isAddToCartAnchor(target)) return;

      e.preventDefault();
      
      const form = findProductForm(target);
      submitProductForm(form);
      stripHashFromUrl();
    },
    { passive: false }
  );

  if (location.hash === '#add-to-cart') {
    stripHashFromUrl();
  }
})();